import { isPseudoLocale } from './pseudo_locale.helpers';
// Shared with the host application's profile preference. Pseudo-locales are a
// browser-only testing override; real locales remain owned by IAM or Axon.
const PSEUDO_LOCALE_STORAGE_KEY = 'medable.ui.pseudoLocale';
export const getStoredPseudoLocale = () => {
    let storedLocale;
    try {
        storedLocale = localStorage.getItem(PSEUDO_LOCALE_STORAGE_KEY);
    }
    catch {
        return undefined;
    }
    if (storedLocale && isPseudoLocale(storedLocale)) {
        return storedLocale;
    }
    if (storedLocale) {
        try {
            localStorage.removeItem(PSEUDO_LOCALE_STORAGE_KEY);
        }
        catch {
            // Storage can be unavailable in private browsing or embedded web views.
        }
    }
    return undefined;
};
export const setStoredPseudoLocale = (locale) => {
    try {
        if (locale && isPseudoLocale(locale)) {
            localStorage.setItem(PSEUDO_LOCALE_STORAGE_KEY, locale);
            return;
        }
        localStorage.removeItem(PSEUDO_LOCALE_STORAGE_KEY);
    }
    catch {
        // Storage can be unavailable in private browsing or embedded web views.
    }
};
